import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiGrid } = FiIcons;

const PreviewBox = ({ layoutWidth }) => {
  return (
    <motion.div 
      className="bg-white rounded-[10px] p-8 shadow-sm border border-gray-100 flex flex-col h-full"
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
    >
      <div className="flex items-center mb-8">
        <div className="mr-3 text-orange-400">
          <SafeIcon icon={FiGrid} className="text-xl" />
        </div>
        <h2 className="text-xl font-bold text-gray-900">Vorschau (Skalierung 1:5)</h2>
      </div>

      <div className="flex-1 bg-[#1F2937] rounded-[10px] p-8 flex flex-col justify-center items-center relative overflow-hidden">
        {/* Visualisierung 3 Spalten */}
        <div className="flex gap-2 w-full max-w-md items-end h-32 mb-4">
          <div className="flex-1 bg-[#374151] rounded-[4px] h-full flex flex-col items-center justify-center border border-gray-600">
            <SafeIcon icon={FiGrid} className="text-gray-500 text-2xl mb-2" />
            <span className="text-[10px] text-gray-400 font-medium">BILD 1</span>
          </div>
          <div className="flex-1 bg-[#374151] rounded-[4px] h-full flex flex-col items-center justify-center border border-gray-600">
            <SafeIcon icon={FiGrid} className="text-gray-500 text-2xl mb-2" />
            <span className="text-[10px] text-gray-400 font-medium">BILD 2</span>
          </div>
          <div className="flex-1 bg-[#374151] rounded-[4px] h-full flex flex-col items-center justify-center border border-gray-600">
            <SafeIcon icon={FiGrid} className="text-gray-500 text-2xl mb-2" />
            <span className="text-[10px] text-gray-400 font-medium">BILD 3</span>
          </div>
        </div>
        
        <div className="mt-4 text-[#FFA22A] font-medium text-sm">
          {layoutWidth}px Gesamtbreite
        </div>
      </div>

      <div className="mt-6 text-center text-xs text-gray-400 uppercase font-medium tracking-wide">
        VISUALISIERUNG: {(layoutWidth / 5).toFixed(0)}PX RASTER (BEISPIEL: 3 SPALTEN)
      </div>
    </motion.div>
  );
};

export default PreviewBox;